import styled from '@emotion/styled';

export const ContentBlock = styled.div`
  height: 100vh;
`;
